import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Input,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { BACKEND_URL } from "../constants";
import accounting from "accounting";

const GiftCardStatus = ({
  profile,
  setProfile,
}: {
  profile: any;
  setProfile: (profile: any) => void;
}) => {
  const [email, setEmail] = useState("");
  const [requesting, setRequesting] = useState(false);

  const requestGiftCard = async () => {
    try {
      setRequesting(true);
      await axios.post(`${BACKEND_URL}/requestGiftCard`, {
        email,
        address: profile.address,
      });
      setProfile({
        ...profile,
        gift_card_requested: true,
      });
    } catch (err) {
      setRequesting(false);
      console.error(err);
    }
  };

  if (profile.gift_card_sent) {
    return (
      <Alert
        status="success"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
        borderRadius="16px"
        mt="12px">
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Gift Card Sent
        </AlertTitle>
        <AlertDescription maxWidth="sm">
          Your gift card has been sent via email.
        </AlertDescription>
      </Alert>
    );
  }

  if (profile.gift_card_requested) {
    return (
      <Box>
        <Alert
          status="info"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="200px"
          borderRadius="16px"
          mt="12px">
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Gift Card Requested
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            Your gift card request has been submitted. You will recieve your
            gift card via email within 1-2 business days.
          </AlertDescription>
        </Alert>
      </Box>
    );
  }

  if (profile.gift_card_amount > 0) {
    return (
      <Box>
        <Text>
          You can claim a{" "}
          <strong>
            {accounting.formatMoney(profile.gift_card_amount, {
              precision: 0,
            })}
          </strong>{" "}
          Sadderday<sup>&reg;</sup> gift card!
        </Text>
        <Text>Enter your email address below to request it.</Text>
        <Input
          mt="20px"
          textAlign="center"
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
          placeholder="Email Address"
        />
        <Button
          isLoading={requesting}
          onClick={requestGiftCard}
          w="100%"
          mt="12px">
          Request Gift Card
        </Button>
      </Box>
    );
  }
  return (
    <Box>
      <Text>We can't find any NFTs in this wallet.</Text>
      <Text>
        If you think there's been a mistake, email us at info@sadderday.com
      </Text>
    </Box>
  );
};

export default GiftCardStatus;
